module.exports = __webpack_public_path__ + "img/02.7756eb18.svg";